import type { OAISchema } from '~/types/openapi';

import { DELIVERABLE_DAYS } from './constants';

export function formatDeliveryFee({
  deliveryFee,
  deliveryFeeType,
  conditionalFreeAmount,
}: {
  deliveryFeeType: OAISchema['MarketDeliveryPolicyResponse']['deliveryFeeType'];
  deliveryFee: number;
  conditionalFreeAmount?: number;
}) {
  if (deliveryFeeType === 'CONDITIONALLY_FREE' && conditionalFreeAmount) {
    return `${conditionalFreeAmount.toLocaleString()}원 이상 무료, 이하 ${deliveryFee.toLocaleString()}원`;
  }

  if (deliveryFeeType === 'FIX') {
    return `${deliveryFee.toLocaleString()}원`;
  }

  if (deliveryFeeType === 'FREE') {
    return '무료배송';
  }

  return null;
}

export const formatDeliverableDays = (
  data: number[],
  includeHolidays?: boolean,
) => {
  return `${data
    .reduce((current, next) => {
      return current.concat(
        DELIVERABLE_DAYS[next as keyof typeof DELIVERABLE_DAYS].text,
      );
    }, [] as string[])
    .join(',')}${includeHolidays ? '' : ' (공휴일 제외)'}`;
};

export const formatDeliveryTotalFee = (
  paymentRes: OAISchema['MarketInShoppingCartPaymentResponse'],
) => {
  const {
    deliveryFee,
    additionalDeliveryFee = 0,
    deliveryFeeType,
  } = paymentRes;

  if (!deliveryFee || deliveryFeeType === 'FREE') return `무료배송`;

  if (!additionalDeliveryFee) {
    return `배송비 ${deliveryFee.toLocaleString()}원`;
  }

  return `배송비 ${deliveryFee.toLocaleString()}원 + 추가배송비 ${additionalDeliveryFee.toLocaleString()}원 포함`;
};

export const formatDeliveryCountdown = (milisecond: number) => {
  const data = (() => {
    // 1s = 1000ms
    // 1m = 60s = 60000ms
    // 1h = 60m = 3600000ms
    // 1d = 24h = 86400000ms

    const d = Math.floor(milisecond / 86400000) || 0;
    const h = Math.floor((milisecond % 86400000) / 3600000) || 0;
    const m = Math.floor((milisecond % 3600000) / 60000) || 0;
    const s = Math.floor((milisecond % 60000) / 1000);

    return {
      d,
      h,
      m,
      s,
    };
  })();

  return data;
};
